import { IFilterableFieldOption } from "../types";
export const findByValue = (
  value: string
): IFilterableFieldOption | null | undefined => {
  return fields.find((f) => f.value === value);
};
export const fields: IFilterableFieldOption[] = [
  {
    value: "SourceId",
    label: "Source",
    inputType: "SOURCE_PICKER"
  },
  {
    value: "MappingSchemaId",
    label: "Schema",
    inputType: "MAPPING_SCHEMA_PICKER_BY_ID"
  },
  {
    value: "EnvironmentId",
    label: "Environment",
    inputType: "ENVIRONMENT_PICKER"
  },
  {
    value: "TeaserMessageTemplate",
    label: "Teaser message template",
    inputType: "TEXT"
  },
  {
    value: "ActorId",
    label: "Actor",
    inputType: "USER_PICKER_BY_ID"
  }
];
